import { render, staticRenderFns } from "./deleteDataPrivilege.vue?vue&type=template&id=7625baa8&scoped=true"
import script from "./deleteDataPrivilege.vue?vue&type=script&lang=js"
export * from "./deleteDataPrivilege.vue?vue&type=script&lang=js"
import style0 from "./deleteDataPrivilege.vue?vue&type=style&index=0&id=7625baa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7625baa8",
  null
  
)

export default component.exports